import { useCallback, useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";
import { useAlert } from "../../context/AlertProvider";
import {
  useSendClinicVerificationCodeMutation,
  useVerifyAndCreateClinicMutation,
  useListClinicsMutation,
  useUpdateClinicMutation,
  useUploadClinicLogoMutation,
} from "../../store/clinicApi";
import useClinicForm from "./useClinicForm";

/**
 * Klinikler sayfasının veri katmanı: liste yükleme + oluşturma formu.
 * Arama/filtre/sıralama/sayfalama `useClientList`'te (sayfa bileşeni).
 */
export default function useClinics() {
  const { auth } = useAuth();
  const token = auth?.accessToken;
  const { showSuccess, showError } = useAlert();

  const [listClinics, { isLoading }] = useListClinicsMutation();
  const [sendClinicVerificationCode] = useSendClinicVerificationCodeMutation();
  const [verifyAndCreateClinic] = useVerifyAndCreateClinicMutation();
  const [updateClinic, { isLoading: isUpdateLoading }] = useUpdateClinicMutation();
  const [uploadClinicLogo] = useUploadClinicLogoMutation();

  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const refresh = useCallback(async () => {
    if (!token) return;
    setErrorMsg("");
    try {
      const res = await listClinics({ token }).unwrap();
      setRows(res?.data?.clinics || []);
    } catch (e) {
      setErrorMsg(e?.data?.message || "Klinikler alınamadı.");
    } finally {
      setLoaded(true);
    }
  }, [token, listClinics]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  // useClinicForm snackbar imzası bekliyor: (mesaj, "success" | "error")
  const notify = useCallback(
    (message, severity = "success") => (severity === "error" ? showError(message) : showSuccess(message)),
    [showError, showSuccess]
  );

  const form = useClinicForm(token, sendClinicVerificationCode, verifyAndCreateClinic, updateClinic, uploadClinicLogo, refresh, notify);

  return { token, rows, loaded, isLoading, errorMsg, refresh, isUpdateLoading, form };
}
